import { AccountType } from '@/components/Modals/CreateAccount/types';
import { CreateAccountType } from '@/components/Modals/SignUp/types';

/**
 * Determines the user's account type and corresponding create account type
 * based on their current roles
 * @returns Object containing accountType and createAccountType
 */
export const getAccountTypes = ({
  isPro,
  isBusiness,
  isCreator,
  isPremium,
  isEssentials,
}: {
  isPro?: boolean;
  isBusiness?: boolean;
  isCreator?: boolean;
  isPremium?: boolean;
  isEssentials?: boolean;
}) => {
  if (isPro || isBusiness) {
    return {
      accountType: AccountType.Pro,
      createAccountType: CreateAccountType.Pro,
    };
  }
  if (isCreator || isPremium) {
    return {
      accountType: AccountType.Creator,
      createAccountType: CreateAccountType.Creator,
    };
  }
  if (isEssentials) {
    return {
      accountType: AccountType.Essentials,
      createAccountType: CreateAccountType.Creator,
    };
  }
  return {
    accountType: AccountType.Free,
    createAccountType: CreateAccountType.Creator,
  };
};
